import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=0b8b849a&"
import script from "./Draggable.ts?vue&type=script&lang=ts&"
export * from "./Draggable.ts?vue&type=script&lang=ts&"
import style0 from "./Draggable.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports